import React, { useContext } from 'react'
import classnames from 'classnames';
import 'rc-image/assets/index.css';
import pcGameDefaultIcon from '@/pages/dashboard/assets/svg/pc-game-default.svg'
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg'
import consoleGameDefaultIcon from '@/pages/dashboard/assets/svg/console-game-default.svg'
import Image from 'rc-image';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import CompanyDefault from '@/pages/home/assets/img/common/company-default.svg';
import PCGameDefault from '@/pages/home/assets/img/common/pcgame-default.png';
import ConsoleGameDefault from '@/pages/home/assets/img/common/consolegame-default.png';
import './index.scss';
// import ImgLoading from '@/pages/home/assets/img/common/image-loading-new.png';
// import ImgLoading from '@/pages/home/assets/img/common/image-loading.png';
import ImgLoading from '@intelligence/assets/svg/loading.svg';
import ImgLoadingBlack from '@intelligence/assets/svg/loading-black.svg';
import SwiperDefault from '@/pages/home/assets/img/common/swiper-default.png';
import VideoDefault from '@/pages/home/assets/img/common/video-default.png';
import UserDefault from '@/pages/home/assets/img/common/user-default.svg';
import ReportDefault from '@/pages/home/assets/img/common/report-default.png';
import { Bubble } from 'tea-component';
import { ThemeContext } from '@/pages/home/wrappers/common';
import { SYSTEM_THEME_DARK } from '@/pages/home/_config/config';

const getLoadingImgByTheme = (theme: string) => {
  if (theme === SYSTEM_THEME_DARK) {
    return ImgLoadingBlack;
  }

  return ImgLoading;
};

//全局统一图片加载组件
export default function GameImage(props: any) {
  const { entityType, src, style, className, alt, moduleType = 'home', onClick, key = '', bubbleContent = '', onLoad, onAbort, onError } = props;
  const { themeValue } = useContext(ThemeContext);

  //根据图片类型返回默认图片，包括
  const getDefaultImg = (moduleType: string, entityType: string) => {
    switch (entityType) {
      case 'mobile':
        return moduleType == 'dashboard' ? mobileGameDefaultIcon : GameDefault;
      case 'pc':
        return moduleType == 'dashboard' ? pcGameDefaultIcon : PCGameDefault;
      case 'console':
      case 'combine':
        return moduleType == 'dashboard' ? consoleGameDefaultIcon : ConsoleGameDefault;
      case 'company':
        return moduleType == 'dashboard' ? CompanyDefault : CompanyDefault;
      case 'swipe':
        return SwiperDefault;
      case 'video':
      case 'background':
        return VideoDefault;
      case 'user':
        return UserDefault;
      case 'report':
        return ReportDefault;
      default:
        return moduleType == 'dashboard' ? mobileGameDefaultIcon : GameDefault;
    }
  }

  return (
    <>
      <Bubble dark content={bubbleContent}>
        <Image
          key={`video-thumb-${alt || key}`}
          className={classnames('dbi-game-image', className, {
            'dbi-game-image--company': entityType === 'company',
          })}
          src={src || getDefaultImg(moduleType, entityType)}
          // placeholder={<img style={style} className={classnames('dbi-game-image--loading-img', className)} src={ImgLoading} />}
          placeholder={
            <div style={style} className={classnames('dbi-game-image--loading-img-wrapper', className)}>
              <img className="dbi-game-image--loading-img" src={getLoadingImgByTheme(themeValue)} />
            </div>
          }
          preview={false}
          fallback={getDefaultImg(moduleType, entityType)}
          onClick={onClick}
          style={style}
          onLoad={onLoad}
          onAbort={(e: any) => {
            e.target.src = getDefaultImg(moduleType, entityType);
            onAbort?.(e);
          }}
          onError={(e: any) => {
            e.target.src = getDefaultImg(moduleType, entityType);
            onError?.(e);
          }}
        />
      </Bubble>
    </>
  )
}
